/**
 * Contact section — previously a portfolio gallery. The example gallery has
 * been removed; the contact card remains so users can find the clinic details
 * and book a consultation.
 */
export const Portfolio = ({ onBook }) => {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="py-20 lg:py-28 bg-[#FFFFFF]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="text-center mb-12 reveal">
          <div
            className="text-[0.6rem] uppercase tracking-[0.32em] mb-3"
            style={{ color: "#B89968" }}
          >
            Contact
          </div>
          <h2
            className="font-serif font-light leading-[0.95]"
            style={{
              color: "#161618",
              fontSize: "clamp(2.5rem, 6vw, 4.75rem)",
              letterSpacing: "0.02em",
            }}
          >
            Get in Touch
          </h2>
          <div className="flex items-center justify-center gap-3 mt-6">
            <span className="h-px w-12" style={{ background: "#B89968" }} />
            <span className="text-xs" style={{ color: "#B89968" }}>♥</span>
            <span className="h-px w-12" style={{ background: "#B89968" }} />
          </div>
          <p className="mt-7 max-w-xl mx-auto text-[#4D4A47] font-light leading-relaxed">
            Private appointments by enquiry. Every treatment journey begins
            with a personal consultation.
          </p>
          <button
            onClick={() => onBook?.()}
            data-testid="portfolio-book-btn"
            className="btn-primary mt-8 inline-flex"
          >
            Book Your Consultation
          </button>
        </div>

        {/* Contact card — single panel */}
        <div
          id="contact"
          className="max-w-2xl mx-auto border border-[#C9BEA9] reveal bg-[#FFFFFF]"
        >
          <div className="p-8 sm:p-12 space-y-6">
            <Info label="Clinic hours" value="By appointment only" />
            <Info label="Location" value="Cumbria · Manchester" />
            <Info
              label="Email"
              value="sfaesthetics20@gmail.com"
              href="mailto:sfaesthetics20@gmail.com"
              testid="contact-email"
            />
            <Info
              label="Phone"
              value="07513 616 311"
              href="tel:+447513616311"
              testid="contact-phone"
            />
            <Info label="Instagram" value="@stacyfoxaesthetics" />
          </div>
        </div>
      </div>
    </section>
  );
};

const Info = ({ label, value, href, testid }) => (
  <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1 sm:gap-6">
    <span className="text-[0.65rem] uppercase tracking-[0.25em] text-[#8C8580] flex-shrink-0">
      {label}
    </span>
    {href ? (
      <a
        href={href}
        data-testid={testid}
        className="font-serif text-base sm:text-lg text-[#161618] sm:text-right hover:text-[#B89968] transition-colors break-all sm:break-words"
      >
        {value}
      </a>
    ) : (
      <span className="font-serif text-base sm:text-lg text-[#161618] sm:text-right break-words">
        {value}
      </span>
    )}
  </div>
);

export default Portfolio;
